module.exports = __webpack_public_path__ + "img/Pipeline1_workflow.a8f7fdd7.png";